export {DiffFinder} from "./diff"
export {nodeToObj} from "./fromDOM"
export {stringToObj} from "./fromString"
